import React from 'react';

function LoadingSpinner({ message = 'Laddar...' }) {
  return <div className="loading">{message}</div>;
}

export default LoadingSpinner;
